/* eslint-disable space-before-function-paren */
const { createElem, debounce } = require('./helpers');

function handleSinglePage() {
  const body = document.querySelector('body');

  function handleGatedCTA() {
    if (!body.querySelector('.embed-block-body')) {
      return;
    }

    function getCover() {
      return body.querySelector('.gated-cover');
    }

    const cover = getCover();

    if (cover) {
      const target = body.querySelector('.single-embed-wrapper .blocking-div');
      const gatedCta = body.querySelector('.block-cta.embed-cta');
      const wrapperElem = createElem('div', { class: 'gated-cta--wrapper' });
      const imgContainer = createElem('div', { class: 'gated-cta--cover' });

      imgContainer.appendChild(cover);
      wrapperElem.appendChild(imgContainer);
      wrapperElem.appendChild(gatedCta);

      target.insertBefore(wrapperElem, target.firstChild);
    }
  }

  function resizeCarouselTiles() {
    const carouselElem = body.querySelector('.related-container');

    if (!carouselElem) {
      return;
    }

    const carouselTiles = [...carouselElem.querySelectorAll('.tile')];

    function resizeHandler() {
      const carouselWidth = carouselElem.clientWidth;
      const tileSize = window.innerWidth > 768 ? (carouselWidth / 2) - 14.5 : carouselWidth; //eslint-disable-line

      for (let i = 0; i < carouselTiles.length; i++) {
        carouselTiles[i].setAttribute('style', `width: ${tileSize}px !important`);
      }
    }

    window.addEventListener('resize', debounce((e) => {
      resizeHandler();
    }));

    resizeHandler();
  }

  function moveBreadcrumbs() {
    const breadcrumbElem = body.querySelector('.bread-crumbs');

    if (!breadcrumbElem) {
      return;
    }

    const target = body.querySelector('.entry-wrapper');
    target.appendChild(breadcrumbElem);
  }

  function handleEntryInfo() {
    const wrapperElem = createElem('div', { class: 'entry-info' });
    const contentElem = createElem('div', { class: 'entry-info--content' });
    const target = body.querySelector('.entry-wrapper');

    function createSocialShare() {
      const shareOptions = {
        facebook: 'facebook',
        twitter: 'twitter',
        email: 'mail',
        linkedin: 'linkedin',
      };
      const cloneShares = function (obj, containerNode) {
        $.each(obj, function (key) {
          const item = $('.share-container .share-item li a.' + key).clone(true);
          item.text('');
          containerNode.append(item);
        });

        return containerNode;
      };

      const socialShareContainer = $('<div>');
      socialShareContainer.addClass('share');
      socialShareContainer.addClass('injected-share');

      const socialShareLabel = $('<span>');
      socialShareLabel.text('Share: ');

      socialShareContainer.append(socialShareLabel);
      cloneShares(shareOptions, socialShareContainer);
      return socialShareContainer;
    }

    function getTitle() {
      return document.querySelector('.entry-wrapper h1');
    }

    function getPurchaseLink() {
      return document.querySelector('a.purchase-link');
    }

    const itemTitle = getTitle();
    const purchaseLink = getPurchaseLink();

    wrapperElem.appendChild(itemTitle);

    $(contentElem).prepend(createSocialShare());

    if (purchaseLink) {
      contentElem.appendChild(purchaseLink);
    }

    wrapperElem.appendChild(contentElem);
    target.insertBefore(wrapperElem, target.firstChild);

  }

  function appendContentIcon() {
    const { tags } = document.getElementById('page-type-identifier').dataset;

    if (!tags) {
      return;
    }

    const contentTags = ['pdf', 'blog', 'video'];

    for (let i = 0; i < contentTags.length; i++) {
      if (tags.includes(contentTags[i])) {
        const target = body.querySelector('.meta-wrapper .meta');
        target.classList.add(contentTags[i]);
        break;
      }
    }
  }


  function handleVisibility() {
    body.querySelector('#hubs-container').style.opacity = '1';
  }

  // disable buttons on flipbook for 20 secs
  function delayFlipbookButtons() {
    const Buttons = document.querySelectorAll('.fullscreen-controls.underneath a');

    Buttons.forEach((link) => {
      link.classList.add('disabled');

      setTimeout(function () {
        link.classList.remove('disabled');
      }, 20000);
    });
  }


  function init() {
    try {
      resizeCarouselTiles();
      moveBreadcrumbs();
      handleEntryInfo();
      handleGatedCTA();
      appendContentIcon();
      handleVisibility();
      delayFlipbookButtons();
    } catch (e) {
      handleVisibility();
    }
  }

  return init();
}

module.exports = handleSinglePage;


// WEBPACK FOOTER //
// ./modules/handleSinglePage.js